import React from 'react';

import Grid, { Col } from 'Components/Grid';
import { ArrowLinkButtonProps } from 'Elements/Button/Arrow';

import { Container, Heading, Description, StyledButton, Wave } from './CampusTour.styled';

export interface Props {
    id: string;
    heading: string;
    description?: string;
    link: ArrowLinkButtonProps;
}

const CampusTour: React.FC<Props> = props => {
    const { id, heading, description, link } = props;

    return (
        <Container id={id}>
            <Grid>
                <Col s={[2, 12]} m={[3, 11]} l={[4, 10]}>
                    <Heading>{heading}</Heading>
                    {description && <Description>{description}</Description>}
                    <StyledButton {...link} />
                </Col>
            </Grid>
            <Wave />
        </Container>
    );
};

export default CampusTour;
